<template>
  <div>
    <nav class="navbar navbar-expand-lg bg-white">
      <div class="container-fluid">
        <AppLogo/>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarToggle"
                aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarToggle">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <AppMenuItems/>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row pb-4" id="contact">
        <h1 class="text-center p-5 fw-bold">{{ $t('contactTitle') }}</h1>
        <p class="text-center" v-html="$t('contactSubtitle')"/>
        <div class="row text-center">
          <h2>{{ $t('needHelp') }}</h2>
          <p class="text-center" v-html="$t('needHelpSubtitle')"/>
        </div>
        <div class="col-md-6 p-5">
          <h2>{{ $t('sendConsultation') }}</h2>
          <p>{{ $t('sendConsultationSubtitle') }}</p>
          <div class="alert alert-success" role="alert" v-if="messageSent">
            {{ $t('consultationReceived') }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <label for="name" class="form-label">{{ $t('name') }} *</label>
              <input type="text" class="form-control" id="name" v-model="name" required>
            </div>
            <div class="mb-3">
              <label for="phone" class="form-label">{{ $t('phone') }}</label>
              <input type="tel" class="form-control" id="phone" v-model="phone">
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">{{ $t('email') }} *</label>
              <input type="email" class="form-control" id="email" v-model="email" required>
            </div>
            <div class="mb-3">
              <label for="message" class="form-label">{{ $t('consultation') }} *</label>
              <textarea class="form-control" id="message" v-model="message" required></textarea>
            </div>
            <button type="submit" class="btn btn-primary">{{ $t('send') }}</button>
          </form>
        </div>
        <div class="col-md-6 p-5">
          <h2>{{ $t('findUsHere') }}</h2>
          <p>{{ $t('findUsHereSubtitle') }}</p>
          <div class="ratio ratio-16x9">
            <img class="img-fluid" :src="require('@/assets/img/map.png')" :alt="$t('mapAlt')"/>
          </div>
          <p class="email text-pink">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt"
                 viewBox="0 0 16 16">
              <path
                  d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"/>
              <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
            </svg>
            Avda. Suero de Quiñones 22
          </p>
          <p class="email">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-envelope" viewBox="0 0 16 16">
              <path
                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
            </svg>
            <a href="mailto:info@flatprive.com">info@flatprive.com</a>
          </p>
          <p class="phone">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-telephone" viewBox="0 0 16 16">
              <path
                  d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path
                  d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
            </svg>
            <a href="tel:+34669769719">+34 669 769 719</a></p>
          <h2>{{ $t('otherContactMethods') }}</h2>
          <p>{{ $t('otherContactMethodsSubtitle') }}</p>
          <p><a href="https://www.instagram.com/flatprive/" target="_blank"><i class="bi bi-instagram"></i>
            Instagram</a></p>
          <p><a href="https://www.facebook.com/flatprive/" target="_blank"><i class="bi bi-facebook"></i> Facebook</a>
          </p>
          <p><a href="https://x.com/flatprive" target="_blank"><i class="bi bi-twitter-x"></i> Twitter</a></p>
          <p><a href="https://www.linkedin.com/company/flatprive" target="_blank"><i class="bi bi-linkedin"></i>
            LinkedIn</a></p>
          <p><a href="https://www.tiktok.com/@flatprive" target="_blank"><i class="bi bi-tiktok"></i> TikTok</a></p>
        </div>
        <div id="modalError" class="modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Ooops!</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="card-body">
                  <p>{{ modalError.message }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppFooter from "@/components/Footer.vue";
import AppMenuItems from "@/components/MenuItems.vue";
import AppLogo from "@/components/Logo.vue";
import axios from "axios";

export default {
  name: 'AppContact',
  components: {AppLogo, AppMenuItems, AppFooter},
  el: '#app',
  data() {
    return {
      modalError: {
        instance: null,
        message: '.'
      },
      name: '',
      phone: '',
      email: '',
      message: '',
      messageSent: false,
      reviews: []
    }
  },
  mounted() {
    document.title = this.generateTitle();
    this.setMeta();
  },
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    },
    pageSize() {
      if (window.matchMedia("(max-width: 600px)").matches)
        return 1
      else
        return 3
    },
    calculatePages() {
      if (window.matchMedia("(max-width: 600px)").matches)
        return Array.from(Array(Math.ceil(this.reviews.length)).keys())
      else
        return Array.from(Array(Math.ceil(this.reviews.length / 3)).keys())
    },
  },
  methods: {
    submitForm: function () {
      if (!this.name || !this.email || !this.message) {
        if (this.es) {
          alert("Por favor, rellena todos los campos obligatorios.");
        } else {
          alert("Please fill in all required fields.");
        }
      } else {
        axios.post('/contact', {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message
        }).then((response) => {
          console.log(response.status);
          this.name = '';
          this.phone = '';
          this.email = '';
          this.message = '';
          this.messageSent = true;
        }).catch((error) => {
          console.log(error);
          const message = this.es ? "Ha ocurrido un error al enviar el formulario. Por favor, inténtalo de nuevo más tarde." : "An error occurred while sending the form. Please try again later.";
          alert(message);
        })
      }
    },
    generateTextReview: function (review) {
      return Array(review.age, review.nationality, review.profession).filter(r => r).join(", ");
    },
    generateMessageMeta: function () {
      if (this.es) {
        return "¿Tienes dudas sobre tu alquiler en León? Contacta con Flatprive y recibe atención personalizada sobre nuestros pisos, habitaciones y colivings. ¡Te ayudamos encantados!";
      } else {
        return "Have questions about your rental in León? Contact Flatprive and receive personalized assistance about our apartments, rooms, and colivings. We’re happy to help you!";
      }
    },
    setMeta: function () {
      let message = this.generateMessageMeta();
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", message);
      } else {
        const meta = document.createElement('meta');
        meta.name = "description";
        meta.content = message;
        document.head.appendChild(meta);
      }
    },
    generateTitle: function () {
      return this.es ? 'Contacto | Flatprive' : 'Contact | Flatprive';
    }
  }
}
</script>

<style scoped src="../assets/css/find.css"></style>
<style scoped src="../assets/css/contact.css"></style>
<style scoped>
:deep(.nav-link) {
  color: #264464 !important;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 400;
}
</style>